import React from "react";
import { useSdkContext } from "scmp-sdk/components/contexts";
import { useGA4CommonParameters } from "scmp-sdk/components/rosetta/hooks";
import { SubscriptionButton } from "scmp-sdk/components/rosetta/subscription-button/styles";

import { PageType } from "shared/lib/page-type";

type Props = {
  className?: string;
  location: "footer" | "masthead" | "print-button";
};
export const SubscribeButton: React.FunctionComponent<Props> = ({ className, location }) => {
  const { config, currentPageType, handleTrackGA4 } = useSdkContext();
  const { computeGA4CommonParameters } = useGA4CommonParameters();
  /*
   * No masthead subs_entry_point_imp for SUBSCRIBE
   * SUBSCRIBE button events would be as frequent as or more than pageviews
   * non-subscriber pageviews are used as a proxy instead
   */
  return (
    <SubscriptionButton
      className={className}
      onClick={() => {
        handleTrackGA4({
          action: "click",
          category: "subs",
          customized_parameters: {
            ...computeGA4CommonParameters(),
            call_to_action: "subscribe",
            trigger_point: (() => {
              switch (location) {
                case "footer":
                  switch (currentPageType) {
                    case PageType.Article:
                      return "article footer";

                    case PageType.Homepage:
                      return "homepage footer";

                    case PageType.Section:
                      return "section footer";

                    default:
                      return "footer";
                  }

                case "masthead":
                  return currentPageType === PageType.Article ? "article masthead" : "masthead";

                case "print-button":
                  return "print article";
              }
            })(),
          },
          subcategory: "entry_point",
        });
        globalThis.location.href = config.subscribe.host;
      }}
    >
      Subscribe
    </SubscriptionButton>
  );
};

SubscribeButton.displayName = "SubscribeButton";
